import React from 'react';
import { motion } from 'framer-motion';
const sensitivities = ['Changing portions day to day', 'Too many treats between meals', 'Switching proteins too quickly', 'Feeding at different times'];
const cycle = ['Tummy acts up', 'You switch the food', 'Things improve briefly', 'Portions get inconsistent', 'It happens again'];
export function ShiftSection() {
  return <section className="py-20 bg-white" data-id="element-189">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        <div className="max-w-3xl mx-auto" data-id="element-191">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center mb-12" data-id="element-192">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1E293B]" data-id="element-193">
              The Pattern Most Owners Don't See
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-[#F8FAFC] rounded-xl border border-[#E2E8F0] p-8 md:p-12" data-id="element-194">
            <p className="text-lg text-[#475569] mb-6 leading-relaxed" data-id="element-195">
              Frenchie bellies are really sensitive to small changes — things
              like:
            </p>

            <ul className="space-y-3 mb-10" data-id="element-196">
              {sensitivities.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center gap-3" data-id="element-197">
                  <div className="w-2 h-2 rounded-full bg-[#0F766E]" data-id="element-198" />
                  <span className="text-lg text-[#475569]" data-id="element-199">{item}</span>
                </motion.li>)}
            </ul>

            <p className="text-lg text-[#475569] mb-4" data-id="element-200">
              Even tiny tweaks can throw things off.
            </p>

            <p className="text-[#1E293B] font-semibold mb-6" data-id="element-201">
              And it usually looks like this:
            </p>

            <div className="flex flex-wrap justify-center gap-2 mb-10" data-id="element-202">
              {cycle.map((step, index) => <div key={index} className="flex items-center" data-id="element-203">
                  <span className="bg-white border border-[#E2E8F0] rounded-lg px-4 py-2 text-sm text-[#475569]" data-id="element-204">
                    {step}
                  </span>
                  {index < cycle.length - 1 && <span className="text-[#94A3B8] mx-1" data-id="element-205">→</span>}
                </div>)}
            </div>

            <div className="pt-8 border-t border-[#E2E8F0] space-y-4" data-id="element-206">
              <p className="text-lg text-[#475569]" data-id="element-207">
                It's not that you're not trying hard enough.
              </p>
              <p className="text-lg text-[#475569]" data-id="element-208">
                It's that there's no{' '}
                <span className="font-semibold text-[#1E293B]" data-id="element-209">
                  consistent routine holding it together
                </span>
                .
              </p>
              <p className="text-[#0F766E] font-semibold text-lg" data-id="element-210">
                And that's exactly what a good routine fixes.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}